import { Routes, RouterModule }  from '@angular/router';
import { PageLayoutsComponent } from './page-layouts.component';
import { PageLayoutProductReleaseListComponent } from './product-release-list/product-release.component';
import { PageLayoutRevisionComponent} from './revision-changelog/revision.component';
import { PageLayoutUserRightsSummaryComponent} from '../user-management/user-rights-summary/userrightssummary.component';
import { PageLayoutRevisionHistoryComponent} from './revision-history/revisionhistory.component';
import { PageLayoutProductReleaseComponent} from './add-edit-productrelease/addproductrelease.component';
import { PageLayoutProductaddComponent} from './add-product/addproduct.component';
import { PageLayoutaddUserComponent} from '../user-management/add-edit-user/adduser.component';
import { PageLayoutUserComponent} from '../user-management/user/user.component';
import {PageLayoutRevertReleaseComponent } from './Revert-Release/revertrelease.component';
import {PageLayoutConfirmDialogComponent } from './confirm-dialog/confirmdialog.component';
import { PageLayoutAllChangeLog } from './view-product-changelog/viewallchangelog.component';
import { PageLayoutProductReleaseTabComponent } from './product-release-tab-list/product-release-tab.component';
import { PageLayoutPushNotificationHistoryComponent } from './push-notification/push-notification-history.component';
import { OTAAuthGuard } from '../shared/ota-auth.guard';


export const PageLayoutsRoutes: Routes = [
    {        
        path: 'pglayout',
        component: PageLayoutsComponent,
        children: [                           
            { path: 'product-release/:name/:id/:code', component: PageLayoutProductReleaseListComponent },
            { path: 'product-release-tab/:name/:id/:code/:variant/:selectedindex', component: PageLayoutProductReleaseTabComponent,pathMatch:'full' },
            { path: 'revision-changelog/:name/:id', component: PageLayoutRevisionComponent},
            { path: 'revision-allchangelog/:name/:id', component: PageLayoutAllChangeLog},
            { path: 'revision-history/:name/:id', component: PageLayoutRevisionHistoryComponent},            
            { path: 'add-edit-productrelease/:name/:id', component: PageLayoutProductReleaseComponent},                        
            { path: 'add-product', component: PageLayoutProductaddComponent},
            { path: 'revert-release/:name/:id', component: PageLayoutRevertReleaseComponent},       
            { path:'confirm-dialog/:title',component:PageLayoutConfirmDialogComponent},
            { path:'push-notification-history/:Title/:id', component:PageLayoutPushNotificationHistoryComponent},
        ],
        canActivate:[OTAAuthGuard],
        canActivateChild:[OTAAuthGuard]
    }
];
export const PageLayoutsRoutingModule = RouterModule.forChild(PageLayoutsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/page-layouts-routing.module.ts